var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-violation", class: [_vm.packageName] },
    [
      _c("div", { staticClass: "data" }, [
        _c("div", { staticClass: "data-box" }, [
          _c("div", { staticClass: "data-desc" }, [
            _c("div", [_vm._v(_vm._s(_vm.data.totalPunishNum || 0))]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.host.totalViolations")))]),
          ]),
          _c("div", { staticClass: "data-desc" }, [
            _c("div", [_vm._v(_vm._s(_vm.data.recent7daysPunishNum || 0))]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.handleOneText(
                    _vm.$t("lang.host.violationInNumDays"),
                    "%s",
                    7
                  )
                )
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "data-box" }, [
          _c("div", { staticClass: "data-desc" }, [
            _c("div", { staticClass: "beans" }, [
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _vm._v(" " + _vm._s(_vm.data.totalPunishBeans || 0) + " "),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.host.totalDeductions")))]),
          ]),
          _c("div", { staticClass: "data-desc" }, [
            _c("div", { staticClass: "beans" }, [
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _vm._v(" " + _vm._s(_vm.data.recent7daysPunishBeans || 0) + " "),
            ]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.handleOneText(
                    _vm.$t("lang.host.deductionsInNumDays"),
                    "%s",
                    7
                  )
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "select" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.$t("lang.host.violationRecords"))),
        ]),
        _c(
          "div",
          { staticClass: "selete-box", on: { click: _vm.showSelete } },
          [
            _c("span", [_vm._v(_vm._s(_vm.seleteText))]),
            _c("img", {
              class: { rotate: _vm.showPopSelete },
              attrs: {
                src: require("@/assets/packageAssets/common/arrow06.png"),
                alt: "",
              },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "header" }, [
        _c("div", [_vm._v(_vm._s(_vm.$t("lang.host.date")))]),
        _c("div", [_vm._v(_vm._s(_vm.$t("lang.host.reason")))]),
        _c("div", [_vm._v(_vm._s(_vm.$t("lang.host.punish")))]),
      ]),
      _c(
        "van-list",
        {
          staticClass: "table",
          attrs: {
            finished: _vm.finished,
            "loading-text": " ",
            "finished-text": _vm.$t("lang.noMore"),
            offset: "200",
          },
          on: { load: _vm.onLoad },
          model: {
            value: _vm.loading,
            callback: function ($$v) {
              _vm.loading = $$v
            },
            expression: "loading",
          },
        },
        [
          _c(
            "table",
            { staticClass: "table-box" },
            _vm._l(_vm.recordList, function (item) {
              return _c("tr", { key: item.level, staticClass: "td-item" }, [
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.handleMoment(item.violateTime, "DD/MM/YYYY"))
                  ),
                ]),
                _c("td", [_vm._v(_vm._s(item.reason))]),
                _c("td", { staticClass: "number" }, [
                  _vm._v(" " + _vm._s(item.punishBeans) + " "),
                  _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
      _c("Selete", {
        attrs: { columns: _vm.columns, showPop: _vm.showPopSelete },
        on: { currentChoose: _vm.currentChoose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }